import bilAPI from "./api";

// BTS booklets (admins only): an exam of a BTS programme folder («БТС-9») for one grade and stream (language),
// whose sections are its subjects' confirmed variants, printed in numbered variants (codes «9101»…). Writes may
// send the `revision` of the last read: 409 booklet_changed when the booklet changed since.
const json = { headers: { "Content-Type": "application/json" } };
const BASE = "/exams/booklets/";

// params: folder, grade, status (draft | active | archived), language (kk | ru), page, page_size.
// Items: {uuid, name, description, folder: {uuid, name}, grade, round_number, language, status, variant_numbers,
// codes, print_labels, duration_minutes, sections_count, documents: {current, job}, revision, created, updated}.
export const getBooklets = ({ params, signal } = {}) => bilAPI.get(BASE, { params, signal }).then((res) => res.data);

// The list fields plus labels, default_labels, check and frozen.
export const getBooklet = (uuid, { signal } = {}) =>
  bilAPI.get(`${BASE}${uuid}/`, { signal }).then((res) => res.data);

// {folder, round_number, grade, subjects: [{folder: {uuid, name, stream}, variants: [<variant of the list>]}]}:
// the folder's subjects of that stream (and those of both) with their variants of the grade.
export const getBookletSources = ({ folder, grade, language }, { signal } = {}) =>
  bilAPI.get(`${BASE}sources/`, { params: { folder, grade, language }, signal }).then((res) => res.data);

// data: {folder, grade, language, name, description?, round_number?, variant_numbers?, print_labels?,
// duration_minutes?} → 201 the detail (a draft).
export const createBooklet = (data) => bilAPI.post(BASE, data, json).then((res) => res.data);

// A draft: any field; an active booklet: name and description (409 booklet_active); archived: 409 exam_archived.
export const patchBooklet = (uuid, data) => bilAPI.patch(`${BASE}${uuid}/`, data, json).then((res) => res.data);

// A draft only.
export const deleteBooklet = (uuid) => bilAPI.delete(`${BASE}${uuid}/`).then((res) => res.data);

// The sections in this order: variant uuids (a draft). Returns the detail.
export const setBookletSections = (uuid, sections, revision) =>
  bilAPI.put(`${BASE}${uuid}/sections/`, { sections, revision }, json).then((res) => res.data);

// {ok, status, grade, round_number, language, codes, frozen, sections: [...], issues: [{code, blocking, ...}]}
export const getBookletCheck = (uuid, { signal } = {}) =>
  bilAPI.get(`${BASE}${uuid}/check/`, { signal }).then((res) => res.data);

// body: {status, confirm?, reason?, allow_non_standard?, revision?}. Returns the detail; an activation adds
// `options_changed` (the questions whose answer order had to be shuffled again).
export const setBookletStatus = (uuid, body) =>
  bilAPI.post(`${BASE}${uuid}/status/`, body, json).then((res) => res.data);
